const ENTITLED= {
    BASE: "Entitled",
    MAIN: undefined,
    ORDERS: {
        _BASE: undefined,
        LIST: undefined,
        FILE: undefined,
        DETAIL: undefined,
        LOG: undefined
    },
    VISITORS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    GUARD: {
        _BASE: undefined
    },
    CHAT: {
        _BASE: undefined
    },
    ORGANIZATIONS: {
        _BASE: undefined,
        LIST: undefined
    },
    GUARD_POSTS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    REGULAR_PASSES: {
        _BASE: undefined,
        LIST: undefined,
        FILE: undefined
    },
    BANS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    },
    FOULS: {
        _BASE: undefined,
        LIST: undefined,
        DETAIL: undefined
    }
};

ENTITLED.MAIN = `${ENTITLED.BASE}|Main`

ENTITLED.ORDERS._BASE = `${ENTITLED.BASE}|Orders`
ENTITLED.ORDERS.LIST = `${ENTITLED.ORDERS._BASE}|List`
ENTITLED.ORDERS.DETAIL = `${ENTITLED.ORDERS._BASE}|Detail`
ENTITLED.ORDERS.LOG = `${ENTITLED.ORDERS._BASE}|Log`
ENTITLED.ORDERS.FILE = `${ENTITLED.ORDERS._BASE}|File`

ENTITLED.VISITORS._BASE = `${ENTITLED.BASE}|Visitors`
ENTITLED.VISITORS.LIST = `${ENTITLED.VISITORS._BASE}|List`
ENTITLED.VISITORS.DETAIL = `${ENTITLED.VISITORS._BASE}|Detail`

ENTITLED.GUARD._BASE = `${ENTITLED.BASE}|Guard`

ENTITLED.CHAT._BASE = `${ENTITLED.BASE}|ChatApprove`

ENTITLED.ORGANIZATIONS._BASE = `${ENTITLED.BASE}|Organizations`
ENTITLED.ORGANIZATIONS.LIST = `${ENTITLED.ORGANIZATIONS._BASE}|List`

ENTITLED.GUARD_POSTS._BASE = `${ENTITLED.BASE}|Guard Posts`
ENTITLED.GUARD_POSTS.LIST = `${ENTITLED.GUARD_POSTS._BASE}|List`
ENTITLED.GUARD_POSTS.DETAIL = `${ENTITLED.GUARD_POSTS._BASE}|Detail`

ENTITLED.REGULAR_PASSES._BASE = `${ENTITLED.BASE}|Regular Passes`
ENTITLED.REGULAR_PASSES.LIST = `${ENTITLED.REGULAR_PASSES._BASE}|List`
ENTITLED.REGULAR_PASSES.FILE = `${ENTITLED.REGULAR_PASSES._BASE}|File`

ENTITLED.BANS._BASE = `${ENTITLED.BASE}|Bans`
ENTITLED.BANS.LIST = `${ENTITLED.BANS._BASE}|List`
ENTITLED.BANS.DETAIL = `${ENTITLED.BANS._BASE}|Detail`

ENTITLED.FOULS._BASE = `${ENTITLED.BASE}|Fouls`
ENTITLED.FOULS.LIST = `${ENTITLED.FOULS._BASE}|List`
ENTITLED.FOULS.DETAIL = `${ENTITLED.FOULS._BASE}|Detail`

export default {
    ...ENTITLED
}
